import { render, staticRenderFns } from "./salesMarginReport.vue?vue&type=template&id=7d917300&"
import script from "./salesMarginReport.vue?vue&type=script&lang=js&"
export * from "./salesMarginReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports